import withHelmet from '../HOC/withHelmet';
import GiftCardDetails from '../components/giftcard/details';

export default withHelmet(
  GiftCardDetails,
  'Give the gift of reading - details',
);
